import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M29.7976 61V32.6364H40.434C42.6129 32.6364 44.4411 33.0149 45.9183 33.772C47.4049 34.5291 48.5267 35.5909 49.2838 36.9574C50.0501 38.3146 50.4333 39.8981 50.4333 41.7077C50.4333 43.5266 50.0455 45.1055 49.2699 46.4442C48.5036 47.7738 47.3725 48.8033 45.8768 49.5327C44.3811 50.2528 42.5437 50.6129 40.3647 50.6129H32.7891V46.3473H39.6723C40.9464 46.3473 41.9897 46.1719 42.8022 45.821C43.6147 45.4609 44.2149 44.9393 44.6027 44.256C44.9997 43.5636 45.1982 42.7141 45.1982 41.7077C45.1982 40.7013 44.9997 39.8427 44.6027 39.1317C44.2056 38.4116 43.6009 37.8668 42.7884 37.4975C41.9759 37.119 40.9279 36.9297 39.6446 36.9297H34.9357V61H29.7976ZM44.4503 48.1477L51.472 61H45.7383L38.8413 48.1477H44.4503Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
